require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-lutzmannsburg.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-lutzmannsburg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-lutzmannsburg!./.cache/json/betreuungseinrichtungen-oberpullendorf-lutzmannsburg.json
// module id = 981
// module chunks = 231608221292675